<template>
    <v-row justify="center">
        <v-dialog v-model="confirm_delete_lead_model" max-width="460px" persistent>
            <v-card class="leads-dialog-card">
                <div class="leads-dialog-header pa-5">
                    <div class="d-flex align-center justify-space-between">
                        <div class="leads-dialog-title">
                            <v-icon class="mr-2" color="white" size="20">mdi-delete-outline</v-icon>
                            Delete Lead
                        </div>
                        <v-btn icon dark @click="eventCloseConfirmDeleteLeadDialog()">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </div>
                <v-card-text class="pa-6">
                    <p style="font-family:Manrope;font-size:14px;color:#3D3D3D;">Are you sure you want to delete this lead? Any data attached to this lead will be deleted.</p>
                    <v-text-field v-model="confirmation" outlined dense placeholder="Type DELETE to confirm" hide-details></v-text-field>
                </v-card-text>
                <v-divider />
                <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn text class="leads-btn" @click="eventCloseConfirmDeleteLeadDialog()">Cancel</v-btn>
                    <v-btn depressed dark color="error" class="leads-btn" @click="eventDeleteLead()" :disabled="confirmation != 'DELETE'">
                        <v-icon small left>mdi-delete</v-icon>
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import { mapGetters } from "vuex"

export default {
    props: {
        show_confirm_delete_lead_dialog: Boolean,
        lead_id: Number
    },
    data: () => ({
        confirm_delete_lead_model: false,
        class: {
        },
        confirmation: null,
    }),
    computed: {
        ...mapGetters({
            get_selected_company: 'auth/get_selected_company',
        })
    },
    mounted() {
    },
    methods: {
        eventCloseConfirmDeleteLeadDialog() {
            this.$emit('eventCloseConfirmDeleteLeadDialog')
            this.confirmation = null
        },
        async eventDeleteLead() {
            const response = await this.$axios.delete(`admin/leads/delete_lead/${this.lead_id}/${this.get_selected_company.id}`)
            const result = response.data
            if (result.response == true) {
                this.$toast.success(result.message, { timeout: 2000, icon: true })
                this.$emit('eventLeadDeleted')
                this.confirmation = null
            } else {
                this.$toast.error(`${response.status}: ${response.statusText}`)
            }
        }
    },
    watch: {
        show_confirm_delete_lead_dialog() {
            this.confirm_delete_lead_model = this.show_confirm_delete_lead_dialog
        }
    }
}

</script>

<style lang="scss" scoped>
.leads-dialog-card {
    border-radius: 12px !important;
    overflow: hidden;
}

.leads-dialog-header {
    background: linear-gradient(135deg, #3988AA 0%, #2a6a88 100%);
}

.leads-dialog-title {
    font-family: Manrope;
    font-size: 18px;
    font-weight: 700;
    color: white;
    display: flex;
    align-items: center;
}

.leads-btn {
    font-family: Manrope;
    font-weight: 600 !important;
    font-size: 13px !important;
    text-transform: none;
}
</style>